import { sampleSizeSymbolCheck, wrapChartCharacters } from "../../commonLogics";
import { BASE_SIZE_MIN_VALUE } from "../../constants";

export const getExperienceSChartOptions = (
  experienceGraph,
  activeDataTypeButton,
) => {
  const datasets = experienceGraph?.datasets || [];
  const maxValue =
    Math.max(...datasets?.flatMap((dataset) => dataset.data), 0) + 25;
  return {
    aspectRatio: 3,
    barThickness: datasets?.length === 1 ? 300 : undefined,
    plugins: {
      legend: {
        display: false,
        position: "top",
        align: "start",
        labels: {
          padding: 20,
          font: { size: 12, weight: "bold" },
          color: "#6C757D",
        },
      },
      tooltip: {
        enabled: false,
      },
      datalabels: {
        // color: "#fff",
        // anchor: "center",
        // align: "center",
        // font: { weight: "bold", size: 14 },
        // formatter: (value) => (value !== 0 ? value : ""),
        labels: {
          value: {
            align: "center",
            anchor: "center",
            color: "#fff",
            font: { weight: "bold", size: 14 },
            formatter: (value) =>
              value !== 0
                ? activeDataTypeButton === "Mean"
                  ? `${parseFloat(value).toFixed(1)}`
                  : `${value}%`
                : "",
          },
          name: {
            align: "end",
            anchor: "end",
            color: "#000",
            offset: 10,
            font: { weight: "bold", size: 14 },
            formatter: (value, context) =>
              context.dataIndex !== 0 && value !== 0 ? `Index:` : "",
          },
          index: {
            align: "end",
            anchor: "end",
            color: "#000",
            offset: -5,
            font: { weight: "bold", size: 16 },
            formatter: (value, context) => {
              return context.dataIndex !== 0 &&
                value !== 0 &&
                context.dataset?.index &&
                context.dataset?.index.length
                ? context.dataset?.index[context.dataIndex]
                : "";
            },
          },
        },
      },
    },
    scales: {
      x: {
        stacked: true,
        ticks: {
          font: { size: 12, weight: "bold" },
          color: (context) => {
            const Index = context.index;
            const baseSizeValue = datasets[Index]?.total_response;
            return baseSizeValue < BASE_SIZE_MIN_VALUE
              ? "#6c757d" // previous color #dc3545(red)
              : "#6C757D";
          },
          callback: function (value, index, values) {
            const label = datasets[index]?.label;
            // const labelVal =
            //   label.length > 18 ? label.slice(0, 18) + "..." : label;
            // return `${labelVal} (N=${datasets[index]?.total_response})`; // Custom label based on the index
            return [
              ...wrapChartCharacters(label),
              `(n=${datasets[index]?.total_response} XMOT surveys)${sampleSizeSymbolCheck(datasets[index]?.total_response, "survey")}`,
            ];
          },
        },
      },
      y: {
        beginAtZero: true,
        suggestedMax: maxValue,
        ticks: {
          callback: (value) => `${value}`,
          font: { size: 12, weight: "bold" },
        },
      },
    },
  };
};
